<template><div><code-well-header>
  <dt-validation-messages
    id="sample--01"
    :validationMessages='[{"message":"Positive validation message","type":"success"}]'
  />
</code-well-header>
<h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Validation messages are typically paired with an input element. They are currently built in to some of our shared input components such as <code v-pre>dt-input</code> and <code v-pre>dt-radio-group</code>.</p>
<h2 id="variants" tabindex="-1" class="d-docsite--header-2">Variants <a class="header-anchor d-link d-docsite--link d-link" href="#variants" aria-hidden="true">#</a></h2>
<h3 id="success-positive" tabindex="-1" class="d-docsite--header-3">Success / Positive <a class="header-anchor d-link d-docsite--link d-link" href="#success-positive" aria-hidden="true">#</a></h3>
<code-well-header>
  <dt-validation-messages
    id="sample--02"
    :validationMessages='[{"message":"Positive validation message","type":"success"}]'
  />
</code-well-header>
<code-example-tabs
htmlCode='
<div class="base-input__messages d-validation-message__container">
  <div role="status" aria-live="polite" class="base-input__message d-validation-message base-input__message--success d-validation-message--success">
    <p>Positive validation message</p>
  </div>
</div>
'
vueCode='
<dt-validation-messages
  id="sample--02"
  :validationMessages=`[{"message":"Positive validation message","type":"success"}]`
/>
'
showHtmlWarning />
<h3 id="critical-error" tabindex="-1" class="d-docsite--header-3">Critical / Error <a class="header-anchor d-link d-docsite--link d-link" href="#critical-error" aria-hidden="true">#</a></h3>
<code-well-header>
  <dt-validation-messages
    id="sample--03"
    :validationMessages='[{"message":"Critical validation message","type":"error"}]'
  />
</code-well-header>
<code-example-tabs
htmlCode='
<div class="base-input__messages d-validation-message__container">
  <div role="status" aria-live="polite" class="base-input__message d-validation-message base-input__message--error d-validation-message--error">
    <p>Critical validation message</p>
  </div>
</div>
'
vueCode='
<dt-validation-messages
  id="sample--03"
  :validationMessages=`[{"message":"Critical validation message","type":"error"}]`
/>
'
showHtmlWarning />
<h3 id="warning" tabindex="-1" class="d-docsite--header-3">Warning <a class="header-anchor d-link d-docsite--link d-link" href="#warning" aria-hidden="true">#</a></h3>
<code-well-header>
  <dt-validation-messages
    id="sample--04"
    :validationMessages='[{"message":"Warning validation message","type":"warning"}]'
  />
</code-well-header>
<code-example-tabs
htmlCode='
<div class="base-input__messages d-validation-message__container">
  <div role="status" aria-live="polite" class="base-input__message d-validation-message base-input__message--warning d-validation-message--warning">
    <p>Warning validation message</p>
  </div>
</div>
'
vueCode='
<dt-validation-messages
  id="sample--04"
  :validationMessages=`[{"message":"Warning validation message","type":"warning"}]`
/>
'
showHtmlWarning />
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="validationmessages" /></div></template>


